// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1pKmw","buttons":"styles__buttons___1AfFD","back":"styles__back___2zhnj"};